module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/suggest.json
// module id = 1394
// module chunks = 188533574006297